import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import {
  Rol,
  Base,
  ReportePermisos,
  ReporteEstructura,
  CategoriaReporte,
  reportCategory,
} from '@app/shared';
import { promise } from 'protractor';
import { resolve } from 'url';

@Injectable()
export class GroupsAdministrationForReportsDataService {
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private api: EndpointService
  ) {}

  getRoles(): Observable<Rol[]> {
    return this.http.get<Rol[]>(this.api.get('roles'));
  }

  /**
 * Consulta los tipos de permisos en el sistema
 *
 * @returns {Observable<Base[]>}
 * @memberof ManagementGroupsPermissionDataService
 */
  getTypePermission(): Observable<Base[]> {
    return this.http.get<Base[]>(this.api.get('typePermissions'));
  }

  getPermissions(idGroup: number): Observable<ReportePermisos[]> {
    return this.http.get<ReportePermisos[]>(this.api.get('adminRolesReports', [idGroup]));
  }

  /**
   * Crear permiso para reportes
   * @param reportePermiso 
   * @returns 
   */
  addPermissionReport(reportePermiso: any): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.skipErrorHandler().post<boolean>(this.api.get('adminRolesReports'), reportePermiso).subscribe(
        resp => {
          this.toastr.success('Operación exitosa', 'Permiso agregado correctamente');
          resolve(true);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', err.error);
          }
          reject(err);
        }
      );
    });
  }

  updatePermissionReport(id: number, reportePermiso: any): Promise<boolean>{
    return new Promise((resolve, reject) => {
      this.http.put<boolean>(this.api.get('adminRolesReports', [id]), reportePermiso).subscribe(
        resp => {
          this.toastr.success('Operación exitosa', 'Permiso modificado correctamente');
          resolve(true)
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.warning('Fallo del sistema', err.error);
          }
          reject(err);
        }
      )
    })
  }

  deletePermissionReport(id: number): Promise<boolean>{
    return new Promise((resolve, reject) => {
      this.http.delete<boolean>(this.api.get('adminRolesReports', [id])).subscribe(
        resp => {
          this.toastr.success('Operación exitosa', 'Grupo eliminado correctamente');
          resolve(true)
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.warning('Fallo del sistema', err.error);
          }
          reject(err)
        }
      )
    })
  }

  
    /**
   * Consulta de todas las categorias de reportes
   *
   * @returns {Observable<CategoriaReporte[]>}
   * @memberof ReportsDataService
   */
    getCategoryReport(): Observable<CategoriaReporte[]> {
    return new Observable(obs => {
      this.http.get<CategoriaReporte[]>(this.api.get('categoryReports')).subscribe(
        categorys => {
          if (categorys && categorys.length) {
            categorys.sort((a, b) => a.id - b.id);
          }
          obs.next(categorys);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  getReportsbyCategory(id: number): Observable<reportCategory> {
    return new Observable(obs => {
      this.http.get<reportCategory>(this.api.get('categoryReports',[id])).subscribe(
        categorys => {
          obs.next(categorys);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/administration/groups-permissions/groups-adminisration-for-reports/shared/groups-administration-for-reports.data.service.ts